var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 36.6667C29.2049 36.6667 36.6668 29.2048 36.6668 20C36.6668 10.7953 29.2049 3.33337 20.0002 3.33337C10.7954 3.33337 3.3335 10.7953 3.3335 20C3.3335 29.2048 10.7954 36.6667 20.0002 36.6667Z",
    fill: "#E6E9F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 14.7916V25.2083H17.7083V14.7916H15.625ZM14.7045 13.8711C14.9155 13.6602 15.2016 13.5416 15.5 13.5416H17.8333C18.1317 13.5416 18.4179 13.6602 18.6288 13.8711C18.8398 14.0821 18.9583 14.3683 18.9583 14.6666V25.3333C18.9583 25.6317 18.8398 25.9178 18.6288 26.1288C18.4178 26.3398 18.1317 26.4583 17.8333 26.4583H15.5C15.2016 26.4583 14.9155 26.3398 14.7045 26.1288C14.4935 25.9178 14.375 25.6317 14.375 25.3333V14.6666C14.375 14.3683 14.4935 14.0821 14.7045 13.8711ZM22.2917 14.7916V25.2083H24.375V14.7916H22.2917ZM21.3712 13.8711C21.5822 13.6602 21.8683 13.5416 22.1667 13.5416H24.5C24.7984 13.5416 25.0845 13.6602 25.2955 13.8711C25.5065 14.0821 25.625 14.3683 25.625 14.6666V25.3333C25.625 25.6317 25.5065 25.9178 25.2955 26.1288C25.0845 26.3398 24.7984 26.4583 24.5 26.4583H22.1667C21.8683 26.4583 21.5822 26.3398 21.3712 26.1288C21.1602 25.9178 21.0417 25.6317 21.0417 25.3333V14.6666C21.0417 14.3683 21.1602 14.0821 21.3712 13.8711Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircle);
export default __webpack_public_path__ + "static/media/pause-circle.afed2a0a421fa0e03bef5e2b5c8dfead.svg";
export { ForwardRef as ReactComponent };